import Render from '@Views/components/popin/layout/popin-default-office-rfe.html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IOffice } from '@Store/types'
import { RfeHelper } from '@Helpers/rfe'

interface IDefaultOfficeRfeOptions {
	ofiId: string
}

@Render
@Component({})
export class PopinDefaultOfficeRfe extends Vue {
	@Prop({ required: true }) options!: IDefaultOfficeRfeOptions
	@Prop({ default: false }) submitted: boolean
	@Prop({ default: false }) loading: boolean

	get offices(): IOffice[] {
		return RfeHelper.activeOffices()
	}

	get ofiId(): string {
		return this.options.ofiId
	}
	set ofiId(value: string) {
		this.options.ofiId = value
	}

	officeName(item: IOffice): string {
		return item && item.coordinates && item.coordinates.name || ''
	}
}
